import { render, staticRenderFns } from "./Followed.vue?vue&type=template&id=6b01b575&scoped=true"
import script from "./Followed.vue?vue&type=script&lang=js"
export * from "./Followed.vue?vue&type=script&lang=js"
import style0 from "./Followed.vue?vue&type=style&index=0&id=6b01b575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b01b575",
  null
  
)

export default component.exports